import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Attacca il token a ogni chiamata verso il backend del portale.
 *
 * I contenuti (aree, protocolli, studi, materiali, moduli, wizard) stanno
 * dietro l'accesso: senza questo, le pagine che chiamavano l'API senza header
 * riceverebbero 401. Il token viaggia solo verso il nostro backend, mai verso
 * altri domini, e non sovrascrive un header già impostato dal chiamante.
 */
export function configuraAxios() {
  axios.interceptors.request.use((config) => {
    const url = config.url || '';
    if (!url.startsWith(API)) return config;
    if (config.headers?.Authorization) return config;
    const token = localStorage.getItem('biounica_token');
    if (token) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });
}
